var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarkerDarkMode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 68,
    viewBox: "0 0 60 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_7525_876)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.3319 11.4884C23.8077 9.7718 26.3941 8 29.9678 8C31.6956 8 33.0094 8.44672 33.0094 8.44672L32.9989 8.45881L33.0274 8.44661C35.4885 9.22319 37.5987 10.8475 38.8695 13.2495L38.8765 13.2477C38.8765 13.2477 40 15.1224 40 17.8178C40 20.7013 38.8636 22.7643 38.8636 22.7643C38.0466 24.4209 36.352 26.4566 35.731 27.2026C35.6445 27.3065 35.5789 27.3853 35.5393 27.4347C34.3592 28.8752 33.1457 30.376 32.1867 32.0625C31.7008 32.9433 31.3897 33.8644 30.9912 35.0765C30.7983 35.6387 30.5489 36.0001 30.0013 36.0001C29.5 36.0001 29.2634 35.7843 29.0115 35.0765L28.988 35.0064C28.5733 33.7651 28.335 33.0518 27.7697 32.0047C27.2966 31.1841 26.3967 29.8289 25.5097 28.7472C25.1349 28.2547 24.7138 27.7446 24.2772 27.2159C23.0787 25.7647 21.764 24.1726 20.9745 22.4179C20.9745 22.4179 20 20.5281 20 17.8051C20 15.233 21.0273 12.9876 22.3355 11.5167L22.3319 11.4884ZM26.8751 15.5946L27.06 15.3808L27.0462 15.3694L27.0472 15.3683C27.0969 15.3083 28.1663 14.0431 29.9987 14.0431C31.9784 14.0431 33.809 15.6417 33.809 17.7624C33.809 18.7012 33.4241 19.455 33.1659 19.8552L33.1585 19.8656L33.0557 19.9961L32.922 20.1542L32.7248 20.3848C32.328 20.768 31.3925 21.4943 30.0013 21.4943C27.8879 21.4943 26.1756 19.8505 26.1756 17.775C26.1756 16.7541 26.6211 15.9628 26.8751 15.5946Z",
    fill: "#A996FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_7525_876",
    x: 0,
    y: 0,
    width: 60,
    height: 68,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 12
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.078875 0 0 0 0 0.0770833 0 0 0 0 0.166667 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7525_876"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7525_876",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerDarkMode);
export default __webpack_public_path__ + "static/media/marker-dark-mode.2f47faa9b46040167e845ffad98118a7.svg";
export { ForwardRef as ReactComponent };